/**
 * @file Вход по логину и паролю с проверкой созданной сессии.
 *
 * SHA-256 пароля — часть существующего серверного протокола входа.
 * Успешного POST недостаточно: возвращаем только проверенные данные пользователя.
 */
import { sha256 } from 'js-sha256'

import type { CustomerInfo } from '../../context/useCustomer'
import { fetchSession } from './api.ts'
import { SignInError } from './signInError.ts'

export async function signIn(
    login: string,
    password: string,
    signal: AbortSignal,
): Promise<CustomerInfo> {
    const response = await fetch('/user-api/customer/session', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: login, password: sha256(password) }),
        signal,
    })

    if ([401, 403, 404].includes(response.status)) {
        throw new SignInError('invalidCredentials')
    }

    if (response.status === 429) {
        throw new SignInError('rateLimited')
    }

    if (!response.ok) {
        throw new SignInError('unavailable')
    }

    return fetchSession(signal)
}
